import type { NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import Layout from 'src/components/common/layout/Layout';
import ForgotPasswordForm from 'src/components/forms/forgot-password/ForgotPasswordForm';
import { getStaticPaths, makeStaticProps } from 'src/utils/helpers/getStatic';

const getStaticProps = makeStaticProps(['forgot_password']);
export { getStaticPaths, getStaticProps };

const ForgotPasswordPage: NextPage = () => {
    const { t } = useTranslation('forgot_password');

    return (
        <Layout backUrl="/" bottombar={false} title={t('page-title')}>
            <ForgotPasswordForm />
        </Layout>
    );
};

export default ForgotPasswordPage;
